<template>
  <div class="row">
    <div
      v-for="report in reports"
      :key="report.fileStem"
      class="col-12 col-md-6 col-lg-4 d-flex"
    >
      <report-card
        class="flex-fill"
        :title="report.title"
        :description="report.description"
        :url="report.url"
        :file-stem="report.fileStem"
      />
    </div>
  </div>
</template>

<script>
import ReportCard from "../components/Cards/ReportCard";

export default {
  name: "Reports",
  components: {
    ReportCard
  },
  data() {
    return {
      reports: [
        {
          title: "Active User Emails",
          description:
            "The name, email address and organization of every active user, across all organizations. Only includes users whose account and group are both active.",
          url: "/reports/active-user-emails",
          fileStem: "active-user-emails"
        },
        {
          title: "Active Device Link Users",
          description:
            "The name, email address and organization of every active user whose group holds a licence pool for the Device Link product.",
          url: "/reports/active-device-link-users",
          fileStem: "active-device-link-users"
        },
        {
          title: "Contract Expiry — Next 30 Days",
          description:
            "Organizations whose contract ends in the next 30 days, with the contract start and end dates and the account manager responsible.",
          url: "/reports/contract-expiry-next-30-days",
          fileStem: "contract-expiry-next-30-days"
        }
      ]
    };
  }
};
</script>
